import { render, staticRenderFns } from "./TrustedBrands.vue?vue&type=template&id=2aa8ed40&scoped=true&"
import script from "./TrustedBrands.vue?vue&type=script&lang=js&"
export * from "./TrustedBrands.vue?vue&type=script&lang=js&"
import style0 from "./TrustedBrands.vue?vue&type=style&index=0&id=2aa8ed40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8ed40",
  null
  
)

export default component.exports